module.exports = __webpack_public_path__ + "images/tabs/documents-on.png";